import { get, post, put, del } from '../../utils/ApiUtil';
import Store from '../../models/Store';
import Page from '../../filters/Page';

/**
 * Get paginated event organizers
 *
 * @param filter
 * @returns {Promise<Page>}
 */
export async function getPaginatedEventOrganizers(filter) {
  const response = await get('/api/user/master/event_organizers', filter);
  // StoreController returns { message: '...', data: { ...pagination data } }
  // We need to extract the data part and convert it to Page format
  const paginationData = response.data;

  // Convert Laravel pagination format to Page class format
  const pageData = {
    data: paginationData.data,
    meta: {
      current_page: paginationData.current_page,
      from: paginationData.from,
      to: paginationData.to,
      last_page: paginationData.last_page,
      per_page: paginationData.per_page,
      total: paginationData.total
    }
  };

  return new Page(pageData, Store);
}

/**
 * Get single event organizer
 *
 * @param id
 * @returns {Promise<Store>}
 */
export async function getEventOrganizer(id) {
  const response = await get(`/api/user/master/event_organizers/${id}`);
  return new Store(response.data);
}

/**
 * Create event organizer
 *
 * @param store
 * @returns {Promise<Store>}
 */
export async function createEventOrganizer(store) {
  const response = await post('/api/user/master/event_organizers', store.toJson());
  return new Store(response.data);
}

/**
 * Update event organizer
 *
 * @param store
 * @returns {Promise<Store>}
 */
export async function updateEventOrganizer(store) {
  const response = await put(`/api/user/master/event_organizers/${store.id}`, store.toJson());
  return new Store(response.data);
}

/**
 * Check if event organizer can be deleted
 *
 * @param id
 * @returns {Promise<{deletable: boolean, message?: string}>}
 */
export async function checkEventOrganizerDeletable(id) {
  const response = await get(`/api/user/master/event_organizers/${id}/check-deletable`);
  return response;
}

/**
 * Delete event organizer
 *
 * @param id
 * @returns {Promise<void>}
 */
export async function deleteEventOrganizer(id) {
  await del(`/api/user/master/event_organizers/${id}`);
}
